import React, {useEffect, useRef, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {RadiiColumnControl} from "./RadiiColumnControl";
import Box, {Item} from "devextreme-react/box";

export function RadiiControl() {
    const data = useCountertops();
    const [collapse, setCollapse] = useState<boolean>(true);
    const boxRef = useRef<Box>(null);

    useEffect(()=>{
        boxRef.current?.instance.repaint();
    }, [data.selectedGroups.length])

    return (
        <>
            <p className={"box-header" + (collapse ? '' : ' box-header-collapsed')}>
                Safety Corners
                <a onClick={() => {
                    setCollapse(!collapse);
                }}>
                    <i className={(collapse ? "dx-icon-spinup" : "dx-icon-spindown") + " dx-icon-custom-style"}
                        style={{ float: "right", fontSize: "32px", lineHeight: "20px" }}></i>
                </a>
            </p>
            {collapse &&
                <div>
                    {data.selectedGroups.length === 0 ? <p>Add shape and material to see Available Radius options</p> :
                        <Box direction={'row'} elementAttr={{ class: 'split-box' }} ref={boxRef}>
                            {data.selectedGroups.map(group =>
                                <Item key={group.prodQteGrpID} ratio={1}>
                                    <RadiiColumnControl group={group} />
                                </Item>
                            )}
                            {data.selectedGroups.length === 1 ? <Item ratio={1} key={'dummy'}></Item> : <></>}
                        </Box>
                    }
                </div>}
        </>
    );
}
